module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/bg-topo-b04a9ffa94996b073d0e9fe87f248267.jpg";